import { Box, Typography } from '@mui/material';
import type React from 'react';

interface WordCountSummaryProps {
  totalWordCount: number;
  coreWordCount: number;
}

export const WordCountSummary: React.FC<WordCountSummaryProps> = ({
  totalWordCount,
  coreWordCount,
}) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 1,
      }}
    >
      <Typography variant="subtitle2" color="text.secondary" sx={{ fontSize: '1rem' }}>
        Total: <strong>{totalWordCount.toLocaleString()}</strong> words
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ fontSize: '1rem' }}>
          Core: <strong>{coreWordCount.toLocaleString()}</strong> words (excludes Executive Summary)
        </Typography>
      </Box>
    </Box>
  );
};
